import { render, staticRenderFns } from "./IconAdd.vue?vue&type=template&id=034585d6&scoped=true"
import script from "./IconAdd.vue?vue&type=script&lang=js"
export * from "./IconAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034585d6",
  null
  
)

export default component.exports